import { PnlEvents } from 'src/constants/events/pnl';
import { ProEvents } from 'src/constants/events/pro';

export interface SegmentUserInfo {
  email: string;
}

export enum SegmentTracks {
  Login = 'accountLoggedIn',
}

export type SegmentEvents = SegmentTracks | ProEvents | PnlEvents;
